module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select-input', {
    attrs: {
      "label": _vm.label,
      "list": _vm.years,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "show-select-disabled": _vm.showSelectDisabled,
      "no-form": _vm.noForm
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c030c27"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectYear.vue
// module id = 1445
// module chunks = 0